export * from './wysihtml.module';

export * from './wysihtml-editor.component';
export * from './wysihtml-toolbar.component';
export * from './wysihtml-toolbar.service';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/index.ts